import { useEffect, useState } from 'react';
import { prefersReducedMotion } from '@/lib/scroll';

const DEFAULT_INTERVAL_MS = 1600;

// 待ち時間を「進捗」に見せるためのステップ送り。active の間だけ index を一定間隔で進め、
// 最後で止まる（ループしない＝やり直しに見えるのを防ぐ）。reduced-motion 時は先頭で静止。
// LoadingOverlay と SiteBrief(analyzing) の進捗表示で共有し、巡回ロジックの重複を避ける。
export function useStepCycle(
  active: boolean,
  count: number,
  intervalMs = DEFAULT_INTERVAL_MS,
): number {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active || count <= 0) return;
    setIndex(0);
    if (prefersReducedMotion()) return;
    const id = window.setInterval(() => {
      setIndex((i) => Math.min(i + 1, count - 1));
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [active, count, intervalMs]);

  return index;
}
